import React, { useState, useEffect } from "react";
import {
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  ListItem,
  List,
  ListItemText,
} from "@mui/material";

import SriyanshCardHeader from "../../components/CardHeader";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

function CreateConsignee() {
  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [newConsigneeName, setnewConsigneeName] = useState("");
  const [newConsigneeCode, setnewConsigneeCode] = useState("");
  const [errors, setErrors] = useState({});
  const [consignees, setconsignees] = useState([]);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate("../", { replace: true });
  };

  const fetchConsignees = async () => {
  try {
      const response = await apiClient.post("/ConsigneeList", {});
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchConsignees();
  }, []);

  const handlenewConsigneeCodeChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Allow only numeric values
      setnewConsigneeCode(value);
    }
  };

  const InsertNewConsignee = async (e) => {
    e.preventDefault();

    // uname,passwrd,rights,newConsigneeName,email,mobile,cretedby,vip,

    let formErrors = {};
    if (!newConsigneeName) formErrors.name = "Consignee/Shop Name is required";
    if (!newConsigneeCode)
      formErrors.newConsigneeCode = "Consignee/Shop Code is required";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      apiClient
        .post("/newconsignee", {
          newConsigneeName,
          newConsigneeCode,
          cretedby: logineuname,
          vip: ip,
        })
        .then(function (response) {
          setErrors(response.data);

          setnewConsigneeName("");
          setnewConsigneeCode("");
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate Consignee Not Allowed");
          }
        });
    }
  };

 return (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
      p: { xs: 1, sm: 1.5, md: 2 },
    }}
  >
    <Card
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 2.5 },
        border: "1px solid #dbe5f0",
        boxShadow: "0 4px 18px rgba(13, 71, 161, 0.10)",
        backgroundColor: "#fff",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.4, sm: 1.6 },
          minHeight: { xs: 54, sm: 60 },
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.15rem", md: "1.3rem" },
            fontWeight: 700,
          }}
        >
          Create New Consignee
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1.25, sm: 2, md: 2.5 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {/* ================= CONSIGNEE INFORMATION ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            border: "1px solid #dbe5f0",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {/* SECTION HEADER */}
          <Box
            sx={{
              px: { xs: 1.25, sm: 1.75 },
              py: 1,
              background:
                "linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)",
              borderBottom: "1px solid #dbe5f0",
            }}
          >
            <Typography
              sx={{
                color: "#0D47A1",
                fontWeight: 700,
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              Consignee Information
            </Typography>
          </Box>

          {/* FORM */}
          <Box
            sx={{
              p: { xs: 1.25, sm: 2, md: 2.5 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
              },
              gap: { xs: 1.5, sm: 2 },
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
            }}
          >
            {/* CONSIGNEE CODE */}
            <TextField
              label="Enter New Consignee/Shop Code"
              size="small"
              variant="outlined"
              type="tel"
              value={newConsigneeCode}
              onChange={handlenewConsigneeCodeChange}
              fullWidth
              error={!!errors.newConsigneeCode}
              helperText={errors.newConsigneeCode}
              inputProps={{
                maxLength: 5,
                pattern: "[0-9]*",
                inputMode: "numeric",
              }}
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                },
                "& .MuiOutlinedInput-root:hover fieldset": {
                  borderColor: "#1976D2",
                },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#1565C0",
                },
              }}
            />

            {/* CONSIGNEE NAME */}
            <TextField
              label="Enter Consignee/Shop Name"
              size="small"
              variant="outlined"
              value={newConsigneeName}
              onChange={(e) =>
                setnewConsigneeName(e.target.value.toUpperCase())
              }
              fullWidth
              error={!!errors.name}
              helperText={errors.name}
              inputProps={{
                maxLength: 30,
              }}
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                },
                "& .MuiOutlinedInput-root:hover fieldset": {
                  borderColor: "#1976D2",
                },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#1565C0",
                },
              }}
            />
          </Box>
        </Box>

        {/* ================= ACTION BUTTONS ================= */}
        <Box
          sx={{
            mt: { xs: 1.5, sm: 2 },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            gap: 1.25,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <button
            className="button button1"
            type="button"
            onClick={InsertNewConsignee}
            title="Click for Data Entry"
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 3px 8px rgba(13, 71, 161, 0.22)",
            }}
          >
            Create Consignee
          </button>

          <button
            className="button button1"
            type="button"
            onClick={handleClose}
            title="Close"
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #c62828 0%, #e53935 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 3px 8px rgba(198, 40, 40, 0.20)",
            }}
          >
            Close
          </button>
        </Box>

        {/* ================= CONSIGNEE LIST ================= */}
        <Box
          sx={{
            mt: { xs: 1.5, sm: 2 },
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            border: "1px solid #dbe5f0",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {/* LIST HEADER */}
          <Box
            sx={{
              background:
                "linear-gradient(135deg, #1565C0 0%, #1976D2 100%)",
              color: "#fff",
              px: { xs: 1.25, sm: 1.75 },
              py: 1,
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "0.9rem", sm: "1rem" },
                fontWeight: 700,
              }}
            >
              Consignee List
            </Typography>
          </Box>

          {/* LIST CONTENT */}
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              height: { xs: 250, sm: 280, md: 300 },
              maxHeight: 300,
              overflowY: "auto",
              overflowX: "hidden",
              backgroundColor: "#fff",
            }}
          >
            {consignees.length > 0 ? (
              <List
                disablePadding
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                }}
              >
                {consignees.map((item) => (
                  <ListItem
                    key={item.ConsigneeCode}
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                      minWidth: 0,
                      boxSizing: "border-box",
                      alignItems: "flex-start",
                      borderBottom: "1px solid #edf2f7",
                      px: { xs: 1.25, sm: 1.5 },
                      py: { xs: 1, sm: 1.15 },
                      transition: "background-color 0.2s ease",
                      "&:hover": {
                        backgroundColor: "#eaf3ff",
                      },
                    }}
                  >
                    <ListItemText
                      sx={{
                        minWidth: 0,
                        m: 0,
                      }}
                      primary={
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "0.8rem",
                              sm: "0.86rem",
                            },
                            fontWeight: 600,
                            color: "#17324d",
                            whiteSpace: "normal",
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                            lineHeight: 1.45,
                          }}
                        >
                          {item.Shop || "-"}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          component="span"
                          sx={{
                            display: "block",
                            mt: 0.25,
                            fontSize: {
                              xs: "0.72rem",
                              sm: "0.78rem",
                            },
                            color: "#607d8b",
                            whiteSpace: "normal",
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                          }}
                        >
                          Code: {item.ConsigneeCode || "-"}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box
                sx={{
                  height: "100%",
                  minHeight: 180,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 2,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "#78909c",
                    fontSize: { xs: "0.8rem", sm: "0.85rem" },
                  }}
                >
                  No consignee found.
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  </Box>
);
}

export default CreateConsignee;
